import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalData } from '../../Modals/ModalData';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { ModalAssignPatients } from './ModalAssignPatients.jsx'
import overlayFactory from 'react-bootstrap-table2-overlay';
import Card from '../../Cards/Card';
function PractitionersInGroup({ onDeletePractitioner, handleTableChange, data, query, totalSize, isLoading, onAssignPatients, allPractitionersAssignments, deletePractitionerButton }) {
    const { t } = useTranslation();

    const columns = [
        { dataField: 'fullName', text: 'Nombre', sort: true },
        {
            dataField: 'pacientes',
            text: 'Pacientes',
            sort: false,
            formatter: (_, row) => {
                
                const practitionerAssignment = allPractitionersAssignments.find(
                    (assignment) => assignment.practitionerId === row.userId
                );

                
                return practitionerAssignment ? practitionerAssignment.count : 0;
            },
        },
        {
            dataField: 'actions1',
            text: 'Acciones',
            formatter: (_, row) => (
                <>
                    <button className="btn btn-primary btn-fill" onClick={() => onAssignPatients(row.userId)}>Asignar</button>

                    {deletePractitionerButton && (
                        React.cloneElement(deletePractitionerButton, { userId: row.userId })
                    )}
                </>
            ),
        }
    ];

    return (
        <BootstrapTable
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"
            keyField="userId"
            data={data}
            columns={columns}
            bootstrap4
            bordered={false}
            hover
            remote
            striped
            loading={isLoading}
            overlay={overlayFactory({ spinner: true })}
            pagination={paginationFactory({
                page: query.pagination.page,
                sizePerPage: query.pagination.sizePerPage,
                totalSize: totalSize,
                hideSizePerPage: true,
                hidePageList: false,
            })}
            onTableChange={handleTableChange}
            noDataIndication={() => <>{t("commons.noData")}</>}
        />
    );
}
export default function GroupPractitionerList({ propsPractitioners, patientsPractitionerProp, deletePractitionerButton }) {
    const { t } = useTranslation();

    const {
        dataPractitioner,
        queryPractitioner,
        totalSizePractitioner,
        isPractitionerLoading,
        handleTableChangePractitioner,
        addPractitioners_Handler,
        deletePractitioner_Handler,
        handleAssignPatientsClick,
        modalPatientsLoading,
        selectedPatient,
        confirmPractitioner,
        handleFilterChangePractitioner,
        deleteAllPractitioners_Handler,
        allPractitionersAssignments,
    } = propsPractitioners;

    return (
        <>
            <PractitionersInGroup
                onDeletePractitioner={deletePractitioner_Handler}
                handleTableChange={handleTableChangePractitioner}
                data={dataPractitioner}
                query={queryPractitioner}
                totalSize={totalSizePractitioner}
                isLoading={isPractitionerLoading}
                onAssignPatients={handleAssignPatientsClick}
                allPractitionersAssignments={allPractitionersAssignments}
                deletePractitionerButton={deletePractitionerButton }
            />
            <ModalAssignPatients
                patientsPractitionerProp={patientsPractitionerProp}
            />
        </>
    );
}